module.exports = __webpack_public_path__ + "static/media/help.40612a0a.svg";